module.exports = __webpack_public_path__ + "static/media/aaj-swift-logo-blackBg.20a35b91.png";